import { httpClient } from '@/shared/api/httpClient';

import { omniboxResultSchema } from '../model/types';
import type { OmniboxResult } from '../model/types';

/**
 * Jedno wywołanie na każde naciśnięcie klawisza (po odczekaniu) — zwraca **naraz**
 * rozpoznaną komendę i trafienia.
 *
 * ⭐ Jeden endpoint, a nie „parsuj" + „szukaj" osobno, i to nie jest oszczędność przelotu:
 * panel kontekstowy ma być **lustrem komendy** (spec sek. 5), więc to, co widać, i to,
 * co się wykona, musi pochodzić z **jednej** odpowiedzi. Przy dwóch wywołaniach panel
 * mógłby pokazywać rozbiór innej wersji tekstu niż lista trafień.
 */
export async function fetchOmnibox(query: string, signal?: AbortSignal): Promise<OmniboxResult> {
  const response = await httpClient.get<unknown>(`/search?q=${encodeURIComponent(query)}`, {
    ...(signal ? { signal } : {}),
  });

  return omniboxResultSchema.parse(response);
}
